/**
 * Feature flag utilities
 * Controls feature visibility via environment variables
 */

/**
 * Check if help system (tours, help sidebar, onboarding) is enabled
 * Default: true (enabled)
 * Set NEXT_PUBLIC_ENABLE_HELP_SYSTEM=false to disable
 */
export function isHelpSystemEnabled(): boolean {
  const envValue = process.env.NEXT_PUBLIC_ENABLE_HELP_SYSTEM;
  // Default to true if not set (backward compatible)
  if (envValue === undefined || envValue === '') {
    return true;
  }
  return envValue.toLowerCase() === 'true';
}

/**
 * Check if debug panel is enabled
 * Default: false (disabled)
 * Set NEXT_PUBLIC_ENABLE_DEBUG_PANEL=true to enable
 * 
 * Note: Debug panel also respects shouldShowDebugTools() logic
 * (dev environment or hostname contains '.dev.')
 * Both conditions must be true for debug panel to show
 */
export function isDebugPanelEnabled(): boolean {
  const envValue = process.env.NEXT_PUBLIC_ENABLE_DEBUG_PANEL;
  // Default to false if not set (secure by default)
  if (envValue === undefined || envValue === '') {
    return false;
  }
  return envValue.toLowerCase() === 'true';
}

